import ABCyaPhaser from '@abcya/abcya_phaser'
import FontKeys from '../FontKeys';
import gameData from '../gameData';

export default class Popup extends Phaser.GameObjects.Container
{
    constructor(scene)
    {
        super(scene);
        scene.add.existing(this);
        this.setDepth(5);

        this.createPopup();
    }

    createPopup()
    {
        this.bgShade = ABCyaPhaser.Graphics.addRect(0, 0, this.scene.mid.x*2, this.scene.mid.y*2, "0x000000", this, {x:0, y:.5}).setAlpha(0);

        if(gameData.LIVES > 0 && !gameData.GAME_DONE){
            const txt = ABCyaPhaser.Localization.instance.getLocalizedString("instructions");

            this.okBtn = this.scene.add.container(this.scene.mid.x, this.scene.mid.y/3);
            this.add(this.okBtn);
            const okBtnBg = ABCyaPhaser.Images.addImage(0,0, "btnOk", this.okBtn);
            ABCyaPhaser.Container.setContainerInteractive(this.okBtn);
            const okBtnTxt= ABCyaPhaser.Text.addText(0,0,120, 0xf4f3e4, FontKeys._curse_casualregular, ABCyaPhaser.Localization.instance.getLocalizedString("ok_button"), this.okBtn);
            ABCyaPhaser.Text.resizeFontToFitWidth(okBtnTxt, 115);

            ABCyaPhaser.Buttons.convertToButton(this.okBtn, {onClick: ()=>{
              this.okBtn.setEnabled(false);
              if(this.endBtn) this.endBtn.setEnabled(false);

              this.clickHandler("ok");
            }}).setEnabled(false);

            this.popupTxt = ABCyaPhaser.Text.addText(0, -this.scene.mid.y/2, 40, "0xFFFFFF", FontKeys._curse_casualregular, txt, this);
            this.popupTxt2 = ABCyaPhaser.Text.addText(0, this.popupTxt.y + this.popupTxt.height + 40, 30, "0xFFFFFF", FontKeys._curse_casualregular, ABCyaPhaser.Localization.instance.getLocalizedString("additional_instructions"), this);
        } else if(gameData.LIVES <= 0 && gameData.GAME_DONE == true) {
            this.endBtn = ABCyaPhaser.Buttons.addSimpleButton(this.scene.mid.x, this.scene.mid.y/3 + 50, "btnReplay", null, ()=>{
                this.endBtn.setEnabled(false);
                if(this.okBtn) this.okBtn.setEnabled(false);

                this.clickHandler("end");
            }, this).setEnabled(false);

            this.popupTxt = ABCyaPhaser.Text.addText(0, -this.scene.mid.y/3, 75, "0xFFFFFF", FontKeys._bumpy_roadregular, ABCyaPhaser.Localization.instance.getLocalizedString("game_over_popup.header"), this);

            if(gameData.WORDS_MADE == 1){
                this.popupTxt2 = ABCyaPhaser.Text.addText(0, this.popupTxt.y + this.popupTxt.height + 40, 30, "0xFFFFFF", FontKeys._curse_casualregular, ABCyaPhaser.Localization.instance.getLocalizedString("game_over_popup.completed_singular").replace("~", gameData.WORDS_MADE).replace("#", gameData.SCORE), this);
            } else {
                this.popupTxt2 = ABCyaPhaser.Text.addText(0, this.popupTxt.y + this.popupTxt.height + 40, 30, "0xFFFFFF", FontKeys._curse_casualregular, ABCyaPhaser.Localization.instance.getLocalizedString("game_over_popup.completed_plural").replace("~", gameData.WORDS_MADE).replace("#", gameData.SCORE), this);
            }

            ABCyaPhaser.Audio.playOneShot("Game_Over_Ghost_Typing", this.scene);
        }

        this.popupTxt.x = this.scene.mid.x;
        this.popupTxt2.x = this.popupTxt.x;

        this.showPopup();
    }

    showPopup(){
        //animate in all the pieces
        this.alpha = 0;
        this.y = this.scene.mid.y;

        ABCyaPhaser.Tweens.addTween(this.bgShade, 750, {alpha:.8}, Phaser.Math.Easing.Linear);
        ABCyaPhaser.Tweens.addTween(this, 750, {alpha:1}, Phaser.Math.Easing.Quadratic.Out, ()=>{
            this.popupReady();
        });
    };

    popupReady(){
        //add listeners and whatnot
        if(this.okBtn){
            this.okBtn.setEnabled(true);
        }
        if(this.endBtn){
            this.endBtn.setEnabled(true);
        }
    };

    clickHandler(btn){
        ABCyaPhaser.Audio.playOneShot("Click", this.scene);

        //Resume the game. Turn back on all listeners
        if(btn == "resume"){
            this.scene.removePopup(btn);
        }

        //Reset the game from the very beginning
        if(btn == "ok"){
            if(gameData.GAME_STATE == "intro"){
                this.scene.destroyIntro();
            }
            if(gameData.GAME_STATE == "game"){
                this.scene.destroyPopup();
            }
        }

        //Reset the game from the very beginning
        if(btn == "end"){
            if(gameData.LIVES <= 0 && gameData.GAME_DONE == true){
                this.scene.destroyGame();
            }
        }
    };

    destroyPopup()
    {
        this.bgShade.destroy();
        this.okBtn?.destroy();
        this.endBtn?.destroy();
        this.popupTxt.destroy();
        this.popupTxt2.destroy();

        this.removeAll();
        super.destroy();
    }
}